import { useEffect, useState, useRef } from 'react'
import { AssetDropDown } from '../../UiComponents/AssetDropDown';
import { useParams, useNavigate } from 'react-router-dom';
import { PortfoliosDropDown } from '../../UiComponents/PortfoliosDropDown';
import { YearDropDown } from '../../UiComponents/YearDropDown';
import { BreadCrumbs } from '../../shared/breadCrumbs/BreadCrumbs';
import { useDispatch, useSelector } from 'react-redux';
import { getAsset } from '../../actions/assetAction';
import { getTaxSettingFields } from '../../actions/taxSettingAction';
import { getTaxDetails } from '../../actions/taxDetailsAction';
import { getTaxSummary } from '../../actions/taxSummaryAction';
import { LoadingScreen } from "../../UiComponents/LoadingComponent";
import { insertOrUpdateAssetTax } from "../../../config/apiConfig";
import { getAssestListddlAction } from '../../actions/assetsddlAction';
import $ from "jquery"
import './TaxDetails.css';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { UrlPath } from '../../../config/routeConfig';
import { TopBar } from "../../shared/topBar/TopBar";
import { ToastContainer, toast } from 'react-toastify';
import { sbaAxios } from "../../utils/sbaAxios";


export const TaxDetails = () => {

    const params = useParams();
    const history = useNavigate();
    const [loading, setLoading] = useState(true);


    const getPreviousYear = () => {
        const currentYear = new Date().getFullYear();
        return currentYear - 1;
    };
    const [TaxYear, SetTaxYear] = useState(getPreviousYear());
    const [render, setRender] = useState(false);
    const [portfolio, setPortfolio] = useState({});
    const [saveDisabled, setSaveDisabled] = useState(true);
    const [userId, setUserId] = useState(20085);


    const dispatch = useDispatch();
    let Level = [{ BreadCrumb: "Asset", Routes: `${UrlPath.Asset}` }]

    const Gstate = useSelector(state => state);
    const isEditable = Gstate.authorizationData.isEditable;
    const asset = useSelector(state => state.asset.asset);
    const taxSetting = useSelector(state => state.taxSetting.taxSetting);
    const portfolioTaxDetail = useSelector(state => state.taxDetails.taxDetails);
    const TaxSummary = useSelector(state => state.taxSummary.taxSummary);


    //grid
    const gridRef = useRef();
    const bookIncomeRef = useRef();
    const [totalTaxableIncomeLoss1, setTotalTaxableIncomeLoss1] = useState(0);
    const [totalTaxableIncomeLoss2, setTotalTaxableIncomeLoss2] = useState(0);
    const [unrealized, setUnrealized] = useState(0);
    const [bookIncome, setBookIncome] = useState(0);
    const [incomeOrexpense, setIncomeOrExpense] = useState(0);
    const [shortTermCapitalGain, setShortTermCapitalGain] = useState(0);
    const [longTermCapitalGain, setLongTermCapitalGain] = useState(0);
    const [summaryOfTaxable, setSummaryOfTaxable] = useState(0);
    const [isBookIncome, setIsBookIncome] = useState();
    const [initialLoad,setInitialLoad]=useState(true);
    const [portfolioTax,setPortfolioTax]=useState([]);

    let IsAssetSelected = useRef(false);

    useEffect(()=>{
        if(initialLoad)
        {
            setInitialLoad(false);
            return;
        }
        else{
            setPortfolioTax(portfolioTaxDetail)
        }
    },[portfolioTaxDetail]);

    useEffect(()=>{
        document.title = "Tax Details";
        ReloadButtonClick()
    },[])
    useEffect(() => {
       
        dispatch(getAssestListddlAction());
        dispatch(getAsset(params.Asset));
        dispatch(getTaxSettingFields(TaxYear));
        if (Object.keys(portfolio).length !== 0) {
            dispatch(getTaxSummary(params.Asset, TaxYear, portfolio.PortfolioId));
            dispatch(getTaxDetails(params.Asset, TaxYear, portfolio.PortfolioId));
            IsAssetSelected.current = true;
        }

    }, [render]);
    const AssetListDDL = useSelector(state => state.assetDDL.assetList);


    useEffect(() => {

        (asset && taxSetting && portfolioTaxDetail && TaxSummary && AssetListDDL) && setLoading(false);
        InitializeSummary();
        setBookIncomeRef();
    }, [Gstate]);

    const ReloadButtonClick = () => {

        if (Object.keys(portfolio).length !== 0) {
            dispatch(getTaxSummary(params.Asset, TaxYear, portfolio.PortfolioId));
            dispatch(getTaxDetails(params.Asset, TaxYear, portfolio.PortfolioId));
        }

        InitializeSummary();
        setSaveDisabled(true);
        setBookIncomeRef();

    };

    const InitializeSummary = () => {
        setIsBookIncome(TaxSummary.IsBookIncome);
        setTotalTaxableIncomeLoss1(TaxSummary.TotalTaxableIncomeLoss1);
        setTotalTaxableIncomeLoss2(TaxSummary.TotalTaxableIncomeLoss2);
        setUnrealized(TaxSummary.Unrealized);
        setBookIncome(TaxSummary.BookIncome);
        setSummaryOfTaxable(TaxSummary.SummaryofTaxable);
        setIncomeOrExpense(TaxSummary.OrdinaryIncomeExpense);
        setShortTermCapitalGain(TaxSummary.ShortTermCapitalGain);
        setLongTermCapitalGain(TaxSummary.LongTermCapitalGain);
    }

    const setBookIncomeRef = () => {
        if (bookIncomeRef.current != null)
            bookIncomeRef.current.value = FormatCurrency(TaxSummary.BookIncome);
    }

    const SaveButtonClick = () => {
        var taxDetails = [];
        let schedule = 0;
        let rate = 0;
        let liability = 0

        gridRef.current.api.forEachNode(function (item, i) {
            schedule = parseFloat(item.data.Schedule);
            rate = parseFloat(item.data.Rate);
            liability = schedule * rate / 100.0;

            taxDetails.push({
                AssetTaxId: item.data.AssetTaxId, AssetId: params.Asset, PortfolioId: portfolio.PortfolioId, Year: TaxYear, LineId: item.data.LineId,
                Schedule: schedule, Rate: rate, Liability: liability, UserId: userId, IsVerified: item.data.IsVerified
            });

        });

        const AssetTaxParamsDTO = {
            "TaxLines": taxDetails,
            "AssetId": parseInt(params.Asset),
            "PortfolioId": portfolio.PortfolioId,
            "Year": TaxYear,
            "TotalTaxableIncomeLoss1": totalTaxableIncomeLoss1,
            "TotalTaxableIncomeLoss2": totalTaxableIncomeLoss2,
            "Unrealized": unrealized,
            "BookIncome": bookIncome,
            "OrdinaryIncomeExpense": incomeOrexpense,
            "ShortTermCapitalGain": shortTermCapitalGain,
            "LongTermCapitalGain": longTermCapitalGain,
            "SummaryofTaxable": summaryOfTaxable,
            "UserId": userId,
            "IsBookIncome": isBookIncome
        }
        

        sbaAxios({
            url: `${insertOrUpdateAssetTax}`,
            method: "post",
            data: JSON.stringify(AssetTaxParamsDTO),
        })
            .then((responseData) => {
                toast.success('AssetTax Updated Successfully', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
                setTimeout(() => {
                    history(`${UrlPath.AssetTax}${params.Asset}`);
                }, 1000);


            })

            .catch((error) => {
                console.log('Error saving: ' + error);
                console.error(error);
            });

        setSaveDisabled(true);
    };


    //Trigger When the Year drop down Changes
    const YearDropDownChanged = (e) => {
      
        SetTaxYear(() => e.value.dateObject.getFullYear());
        setRender(!render);
    }

    //Trigger When the Asset drop down Changes
    const AssetDropDownChanged = (e) => {

        if (e.value) IsAssetSelected.current = true;
        else
            IsAssetSelected.current = false;

        e.value && history(`${UrlPath.AssetTaxDetails}${e.value.AssetId}`);
        e.value && dispatch(getAsset(e.value.AssetId));
        e.value && setRender(!render);
    }

    //Trigger when the portfolio drop down changed
    const PortfoliosDropDownChanged = (e) => {
        e.value && setPortfolio(e.value);
        e.value && setRender(!render);
    }

    const IsBookIncomeHandler = (e) => {
        setIsBookIncome(!isBookIncome);
        CalculateUnrealized();


    }


    //  calculate unrealized textbox
    const CalculateUnrealized = (event) => {
        let totalincome1 = 0;
        let bookIncome1 = 0;
        let unrealized = 0;

        if ($('#txtTotaltaxableIncome1').val() !== '' && $('#txtTotaltaxableIncome1').val() !== null) {
            totalincome1 = parseFloat($('#txtTotaltaxableIncome1').val().replace(/\,/g, ''));
        }

        if ($('#txtBookIncome').val() !== '' && $('#txtBookIncome').val() !== null) {
            bookIncome1 = parseFloat($('#txtBookIncome').val().replace(/\,/g, ''));
            setBookIncome(bookIncome1);
        }

        unrealized = bookIncome1 - totalincome1;
        setUnrealized(unrealized);

        CalculateFooterTotals();

    };


    const CalculateFooterTotals = () => {

        let totalIncome1 = 0;
        let totalIncome2 = 0;
        let shortTermGain = 0;
        let shortTermGainT = 0;
        let longtTermGain = 0;
        let longTermGainT = 0;
        let section1256gainloss1 = 0;
        let section1256gainloss2 = 0;
        let incomeOrexpense = 0;
        let unrealized1 = 0;
        let bookIncome1 = 0;
        let totalTaxbleIncome = 0;



        gridRef.current.api.forEachNode(function (item, i) {
            let schedule = parseFloat(item.data.Schedule);
            let classification = item.data.Classification.trim().toLowerCase();
            let rate = parseFloat(item.data.Rate);


            if (classification !== "qualifying dividends") {
                totalIncome1 += + schedule;
            }

            if (classification === "short-term capital gain(loss)") {
                shortTermGain += schedule;
            }
            else if (classification === "long-term capital gain(loss)") {
                longtTermGain += schedule;
            }
            else if (classification === "section 1256 gain(loss)") {
                section1256gainloss1 = Math.round(schedule * 0.4, 0);
                section1256gainloss2 = Math.round(schedule * 0.6, 0);
            }

            if (schedule != null && schedule !== 0 && classification !== 'qualifying dividends' && classification !== 'short-term capital gain(loss)' && classification !== 'long-term capital gain(loss)' && classification !== 'section 1256 gain(loss)') {
                incomeOrexpense += + schedule;
            }

            totalIncome2 += schedule * rate / 100.0;

        });


        setTotalTaxableIncomeLoss1(totalIncome1);
        setTotalTaxableIncomeLoss2(totalIncome2);

        if ($('#txtBookIncome').val() !== '' && $('#txtBookIncome').val() !== null) {
            bookIncome1 = parseFloat($('#txtBookIncome').val().replace(/\,/g, ''));
            setBookIncome(bookIncome1);
        }

        unrealized1 = bookIncome1 - totalIncome1;

        setUnrealized(unrealized1);
        setIncomeOrExpense(incomeOrexpense);

        shortTermGainT = shortTermGain + section1256gainloss1;
        setShortTermCapitalGain(shortTermGainT);

        longTermGainT = longtTermGain + section1256gainloss2;
        setLongTermCapitalGain(longTermGainT);

        totalTaxbleIncome = incomeOrexpense + shortTermGainT + longTermGainT
        setSummaryOfTaxable(totalTaxbleIncome)

        IsAssetSelected.current && setSaveDisabled(false);

    }

    // Formatting the number using thousand separators
    const ThousandsSeparators = (num) => {
        if (num != undefined) {
            let num_parts = num.toString().split(".");
            num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return num_parts.join(".");
        }
    }

    const FormatCurrency = (num) => {
        if (num != undefined) {
            return num.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })
        }
        else return '';
    }

    const FormatCurrencyGrid = (params) => {
        var num = params.value;
        if (num != undefined) {
            return "$ " + num.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })
        }
        else return num;
    }

    const FormatPctGrid = (params) => {
        var num = params.value;
        if (num != undefined) {
            return num.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }) + " %"
        }
    }



    // BookIncome Textbox Value format using thousand separators

    $("#txtBookIncome").focusout(function () {
        let BookIncome = $('#txtBookIncome').val().replace(/,/g, '');

        if (BookIncome != null && BookIncome != "")
            $('#txtBookIncome').val(ThousandsSeparators(BookIncome));
    });




    // Allow Numbers only
    const NumberOnly = (event) => {
        let regexNumber = /^\$?(((\d)\,?)+)?((\d)+)(\.(\d)+)?$/;
        // Allow only backspace, delete, dot, arrow key, tab, shift+tab
        if (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 189 || event.keyCode == 109 || event.keyCode == 190 || event.keyCode == 110 || (event.keyCode >= 37 && event.keyCode <= 40) || event.keyCode == 9 || event.keyCode == 16) {
            // let it happen, don't do anything

        } else {
            // Allow copy, paste, select all only numbers 
            if (((event.keyCode == 65 || event.keyCode == 86 || event.keyCode == 67) && (event.ctrlKey === true || event.metaKey === true))) {
                if (event.originalEvent.clipboardData.getData('Text').match(regexNumber) == null) {
                    event.preventDefault();
                }
            }
            // Ensure that it is a number and stop the keypress

            if ((event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105)) {
                event.preventDefault();
            }
        }
    }
    //When the Loading state is set to false the Complete new Level of Bread Crumbs is Loaded
    Level = !loading ? ([...Level, { BreadCrumb: `> ${asset.AssetName} >`, Routes: `${UrlPath.AssetDetails}${params.Asset}` }, { BreadCrumb: `Tax`, Routes: `${UrlPath.AssetTaxDetails}${params.Asset}` }]) : Level;

    const columnDefs = [
        { field: "AssetTaxId", hide: true, flex: 1 },
        { field: "LineId", hide: true, flex: 1 },
        { field: "LineName", headerName: "K-1 Line", flex: 1 },
        { field: "Classification", headerName: "Income/Expense Classification", flex: 1 },
        {
            field: "Schedule",
            editable: true,
            headerName: "Per Schedule K-1",
            valueFormatter: FormatCurrencyGrid,
            singleClickEdit: true,
            cellStyle: { textAlign: "right" },
            flex: 1
        },
        { field: "GeneralClassification", headerName: "General Classification", flex: 1 },
        {
            field: "Rate",
            headerName: "Rate *",
            editable: true,
            singleClickEdit: true,
            valueFormatter: FormatPctGrid,
            flex: 1

        },
        {
            field: "Liability",
            headerName: "Potential Tax Liability",
            valueFormatter: FormatCurrencyGrid,
        valueGetter: 'data.Schedule * data.Rate/100.0',
            cellStyle: { textAlign: "right" },
            flex: 1

        },
        {
            field: "IsVerified",
            editable: true,
            cellClass: "me-1",
            flex: 1
        },


    ];

    var gridOptions = {
        onCellValueChanged: event => {
            CalculateFooterTotals();
        }
    }

    console.log("portfolioTaxDetail", portfolioTaxDetail)

    return (
        <>{loading ? <><LoadingScreen /></> : <>
            <TopBar label={"Tax Details"} />
            <div id="content" className="mainContentData taxDetails">
                <BreadCrumbs Levels={Level} />
                <div className='container-fluid TaxPage'>
                    <form >
                        <div className="row">
                            <div className="col-md-3 col-lg-3">
                                <label htmlFor="select fund" className="mb-1">Select Asset</label>
                                <AssetDropDown value={asset} onChange={AssetDropDownChanged} data={AssetListDDL} />
                            </div>
                            <div className="col-md-2 col-lg-2">
                                <label htmlFor="select Year" className="mb-1">Year</label>
                                <YearDropDown DropDownListChanged={YearDropDownChanged} value={TaxYear} />
                            </div>

                            <div className="col-md-2 col-lg-3">
                                <label htmlFor="select Portfolio" className="mb-1">Select Portfolio</label>
                                <PortfoliosDropDown DropDownListChanged={PortfoliosDropDownChanged} />
                            </div>
                            <div className="col-md-2 d-flex align-items-lg-end"  >
                                <button type="submit" className='p-sm-btn mx-1' disabled={saveDisabled || !isEditable} onClick={SaveButtonClick}><i className="fa-solid" /> Save</button>
                                <button className="p-sm-btn mx-1" onClick={ReloadButtonClick}> Reload</button>
                            </div>
                        </div>
                    </form>


                    {<div className='MainGrid'>
                        <div
                            id='TaxDetails'
                            className="ag-theme-alpine">
                            <AgGridReact
                                ref={gridRef}
                                domLayout='autoHeight'
                                columnDefs={columnDefs}
                                rowData={portfolioTax}
                                pagination={false}
                                suppressRowVirtualisation={true}
                                gridOptions={gridOptions}
                                defaultColDef={{resizable:true}}
                            />
                        </div>
                    </div>
                    }
                </div>
                {(TaxSummary) &&
                    <div className='TaxSubTable'>
                        <div>
                            <table>
                                <tbody>
                                    <tr>
                                        <th>Total Taxable Income (loss)</th>
                                        <td>
                                            <div className="input-group">
                                                <span className="input-group-text" style={{ height: "32px" }}>$</span>

                                                <input type='text' className="form-control" defaultValue={FormatCurrency(totalTaxableIncomeLoss1)} id='txtTotaltaxableIncome1' style={{ textAlign: "right" }} disabled />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Unrealized</th>
                                        <td>
                                            <div className="input-group">
                                                <span className="input-group-text" style={{ height: "32px" }}>$</span>
                                                <input type='text' className="form-control" id='txtUnrealized' defaultValue={FormatCurrency(unrealized)} style={{ textAlign: "right" }} disabled />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Book Income</th>
                                        <td>
                                            <div className="input-group">
                                                <span className="input-group-text" style={{ height: "32px" }}>$</span>
                                                <input type="text" className="form-control" defaultValue={FormatCurrency(bookIncome)} tabIndex="130" id="txtBookIncome"
                                                    style={{ textAlign: "right" }} onChange={CalculateUnrealized} onKeyDown={(e) => { NumberOnly(e) }} ref={bookIncomeRef} />

                                            </div>

                                        </td>
                                    </tr>
                                    <tr>
                                        <th></th>
                                        <td>
                                            <div className="input-group">
                                                <input type="checkbox" id="txtIsBookIncome" checked={isBookIncome} onChange={IsBookIncomeHandler} ></input> <label> Is Book Income </label>

                                            </div>

                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Summary of Taxable</th>
                                        <td>
                                            <div className="input-group">
                                                <span className="input-group-text" style={{ height: "32px" }}>$</span>
                                                <input type='text' id={'txtSummaryofTaxableTotal'} className="form-control" defaultValue={FormatCurrency(summaryOfTaxable)} style={{ textAlign: "right" }} disabled />

                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Ordinary Income/Expense</th>
                                        <td>
                                            <div className="input-group">
                                                <span className="input-group-text" style={{ height: "32px" }}>$</span>
                                                <input type='text' id={'txtIncomeOrexpense'} className="form-control" defaultValue={FormatCurrency(incomeOrexpense)} style={{ textAlign: "right" }} disabled />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Short-Term Capital Gain (loss)</th>
                                        <td>
                                            <div className="input-group">
                                                <span className="input-group-text" style={{ height: "32px" }}>$</span>
                                                <input type='text' className="form-control" id={'txtShortTermGain'} defaultValue={FormatCurrency(shortTermCapitalGain)} style={{ textAlign: "right" }} disabled />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Long-Term Capital Gain (loss)</th>
                                        <td>
                                            <div className="input-group">
                                                <span className="input-group-text" style={{ height: "32px" }}>$</span>
                                                <input type='text' className="form-control" id={'txtLongTermGain'} defaultValue={FormatCurrency(longTermCapitalGain)} style={{ textAlign: "right" }} disabled />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div >
                            <table>
                                <tbody>
                                    <tr>
                                        <th>Potential Tax Liability</th>
                                        <td>
                                            <div className="input-group"  >
                                                <span className="input-group-text" style={{ height: "32px" }}>$</span>
                                                <input type='text' className="form-control" id='txtTotaltaxableIncome2' defaultValue={FormatCurrency(totalTaxableIncomeLoss2)} style={{ textAlign: "right", width: "150px" }} disabled />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>}
            </div>
            <ToastContainer></ToastContainer>
        </>}
        </>
    )
}
